export default {
  CollectMoney: '收款',
  CollectionOrder: '收款订单',
  Payment: '付款',
  PaymentOrder: '付款订单',
  AllMerchants: '所有商户',
  header: {
    language: '语言',
    ChinaTime: '本平台所有时间都是中国时间',
    Received: '订单到账金额',
    OrderNumber: '订单数量',
    CreationOrder: '这里的时间归因是：创建订单的时间',
    eg: '举例：9 -13 23:50:00 拉起，9 -14 00:01:00成功回调支付，则在支付后台算作13日的订单。'
  },
  search: {
    CreationStartTime: '创建开始日期',
    CreationEndTime: '创建结束日期',
    OrderStatus: '订单状态',
    GatewayQuery: '网关查询',
    Inquire: '查询',
    Export: '导出',
    batchPayOutDate: '批量查询代付订单时间',
    batchPayOutGateway: '批量查询代付订单的网关',
    batchPayOutInquire: '批量查询代付订单',
    StartDate: '开始日期',
    to: '至',
    EndDate: '结束日期',
    Refresh: '刷新'
  },
  table: {
    CreationTime: '创建时间',
    CreationTimeLocal: '创建时间(北美)',
    UpdateTime: '更新时间',
    UpdateTimeLocal: '更新时间(北美)',
    UserName: '用户名称',
    Email: '邮箱',
    Phone: '手机号',
    ReasonFailure: '失败理由',
    Account: '账户',
    OrderAmount: '订单金额',
    CurrencyCode: '货币符号',
    ExchangeRate: '汇率',
    ExchangeRateAmount: '汇率后金额',
    NumberNotifications: '通知次数',
    WhetherNotify: '是否通知到',
    Forward: '推送',
    ForwardMessages: '推送消息',
    GoBack: '退回',
    Refund: '退款',
    State: '状态'
  },
  merchant: {
    PaymentChannel: '付款通道',
    PaymentKey: '付款的Key',
    PaymentChannelRemarks: '付款通道备注',
    CollectionChannel: '收款通道',
    CollectionKey: '收款的Key',
    CollectionChannelRemarks: '收款通道备注',
    CollectionWeightStatus: '代收权重状态',
    limitedTime: '限制的时间',
    TotalCollectionAmount: '每日代收总额上限',
    LowerSinglePayAmount: '代付单笔下限金额',
    SupperSinglePayAmount: '代付单笔上限',
    AccountBalancePaid: '账户余额(可代付)',
    SingleLowerCollectionAmount: '代收单笔下限金额',
    SingleUpperCollectionAmount: '代收单笔上限',
    PayWeightStatus: '代付权重状态',
    TotalPaymentToday: '今日收款总额',
    TotalCurrentReceipts: '当前收款总额(待转移)',
    WithdrawalFee: '提现手续费',
    PayProcessingFees: '支付手续费',
    TransferAmount: '转移金额'
  },
  PaymentTrends: {
    PaymentTrends: '支付趋势',
    PullupToday: '今日拉起笔数',
    SuccessfulToday: '今日成功笔数',
    PullupYesterday: '昨日拉起笔数',
    SuccessfulYesterday: '昨日成功笔数',
    PullupLastWeek: '上周拉起笔数',
    SuccessfulLastWeek: '上周成功笔数',
    Pullup: '{channel} 拉起笔数',
    Successful: '{channel} 成功笔数'
  },
  common: {
    PlatformOrderID: '平台订单号',
    MerchantID: '商户ID号',
    MerchantOrderNumber: '商户订单号',
    ApplicationName: '应用名称',
    MerchantName: '商户名称',
    SecretKey: '密钥',
    UserID: '用户 ID',
    Country: '国家',
    Gateway: '网关',
    GatewayID: '网关 ID',
    Channel: '通道',
    ChannelName: '通道名称',
    PaymentChannel: '支付渠道',
    AddAmount: '添加金额',
    Edit: '编辑',
    Delete: '删除',
    Operate: '操作',
    Collectionbalance: '代收余额',
    Availablechannel: '可用通道',
    AddAvailablechannel: '添加可用通道',
    CurrentChannelConfig: '当前通道配置',
    AddChannel: '添加渠道'
  },
  general: {
    index: '序号',
    operations: '操作',
    delete: '删除',
    cancel: '取消',
    confirm: '确认',
    tip: '提示',
    getDataFailed: '获取数据失败',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败'
  },
  trustDecision: {
    whitelist: '白名单管理',
    addIP: '添加 IP',
    addWhitelist: '添加白名单',
    ipAddress: 'IP 地址',
    enterIP: '请输入 IP 地址',
    confirmDelete: '确认删除此 IP？',
    invalidIP: 'IP 地址格式无效',
    ipRequired: '请输入 IP 地址'
  }
};